import { memo, ReactElement, Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';
import { useGpsTracking } from '../../../hooks/useGpsTracking';

const { GpsTrackingPopup } = lazy(
  () =>
    import(/* webpackChunkName: "gps-tracking-popup" */ './gpsTrackingPopup')
);

export const GpsTracking = memo((): ReactElement | null => {
  const GpsTrackingParams = useGpsTracking();

  return GpsTrackingParams.popupType ? (
    <Suspense fallback={null}>
      <GpsTrackingPopup />
    </Suspense>
  ) : null;
});
